export type ImgOptConfig = {
	quality?: number;
	cropping?: string;
	path: string;
	size?: string;
	mode?: string;
};

export default ({
	path,
	cropping = '',
	size = '',
	quality = 70,
	mode = 'publish',
}: ImgOptConfig) => {
	const paramsString = [quality, size, cropping.replace(/\./g, ',')];

	return encodeURI(`/alt/img-opt/~${paramsString.join('.')}/${mode}${path}`);
};
